import type { RenderComponentProps } from "replo-runtime/shared/types";

import React from "react";

import { useBundleBuilder } from "../BundleBuilderContext";
import { BundleCartItem } from "./BundleCartItem";

export const BundleCart: React.FC<RenderComponentProps> = ({
  componentAttributes,
}) => {
  const { bundleCartItems, removeItemFromBundle, getEmptySlots } =
    useBundleBuilder();

  const emptySlots = getEmptySlots();

  // Create empty slot placeholders
  const emptySlotElements = new Array(emptySlots).fill(0).map((_, index) => (
    <div
      key={`empty-slot-${index}`}
      style={{
        width: "80px",
        height: "80px",
        borderRadius: "8px",
        border: "2px dashed #ccc",
        backgroundColor: "#f9f9f9",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#999",
      }}
    >
      <span style={{ fontSize: "24px", fontWeight: "300" }}>+</span>
    </div>
  ));

  return (
    <div
      {...componentAttributes}
      style={{
        width: "100%",
        display: "flex",
        flexWrap: "wrap",
        gap: "12px",
        ...componentAttributes?.style,
      }}
    >
      {bundleCartItems.map((item) => (
        <BundleCartItem
          key={`cart-item-${item.variantId}`}
          item={item}
          onRemove={() => removeItemFromBundle(item.variantId)}
        />
      ))}

      {emptySlotElements}
    </div>
  );
};
